import React, { createContext, useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

interface EmbedHostContextValue {
  isEmbedMode: boolean;
}

const EmbedHostContext = createContext<EmbedHostContextValue>({ isEmbedMode: false });

export function EmbedHostProvider({ children }: { children: React.ReactNode }) {
  const [searchParams] = useSearchParams();
  const isEmbedMode = searchParams.get('embed') === '1';

  const value = useMemo(() => ({ isEmbedMode }), [isEmbedMode]);

  return <EmbedHostContext.Provider value={value}>{children}</EmbedHostContext.Provider>;
}

export function useEmbedHost(): EmbedHostContextValue {
  return useContext(EmbedHostContext);
}
